import { caseInsensitiveIncludes } from './caseInsensitiveIncludes'

export function filterForms (forms, { status, search }) {
  if (!forms) return []

  /** 已勾選的欲篩選的表單狀態的 id 集合 */
  const selectedStatusKeys = new Set(
    status
      .filter(status => status.value)
      .map(status => status.key)
  )

  /** 會被搜尋的欄位 */
  const searchableStringFields = ['name', 'school', 'song', 'email', 'phone']

  return forms.filter(form => {
    const isStatusMatched = selectedStatusKeys.has(form.status)
    const isSearchKeywordMatched =
      !search ||
      searchableStringFields.some((field) => caseInsensitiveIncludes(form[field], search))

    return isStatusMatched && isSearchKeywordMatched
  })
}
